import React from "react";

import { Textarea, Field, Label, Control, Input, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PropTypes from "prop-types";
import {
  BooleanInput,
  CurrencyInput,
  DateInput,
  SystemCodeSelect
} from "../inputs";

const TariffForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field kind="group">
      <Control>
        <Label>Tariff Code</Label>
        <Input
          autocomplete="new"
          name="TariffCode"
          type="text"
          value={inputs?.TariffCode}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <SystemCodeSelect
          icon="globe"
          label="Tariff Type"
          lookup={{ Category: "Tariff", Code: "TariffType" }}
          name="TariffTypeRecIdRef"
          value={inputs?.TariffTypeRecIdRef}
          valueKey="RecId"
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Active</Label>
        <BooleanInput name="Active" value={inputs.Active} onChange={onChange} />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Description</Label>
        <Textarea
          name="Description"
          rows="3"
          type="text"
          value={inputs?.Description}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <Label>Begin Date</Label>
        <DateInput
          name="BeginDate"
          value={inputs?.BeginDate}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>End Date</Label>
        <DateInput name="EndDate" value={inputs?.EndDate} onChange={onChange} />
      </Control>
    </Field>
    <Field kind="group">
      <Control>
        <Label>Fuel Surcharge Rate</Label>
        <Field kind="addons">
          <Control expanded>
            <Input
              name="FuelSurchargeRate"
              value={inputs.FuelSurchargeRate}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Button static>
              <Icon>
                <FontAwesomeIcon icon="percent" />
              </Icon>
            </Button>
          </Control>
        </Field>
      </Control>
      <Control>
        <Label>Min. Charge</Label>
        <CurrencyInput
          name="MinCharge"
          value={inputs?.MinCharge}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <Label>Min. Load</Label>
        <Input
          autocomplete="new"
          name="MinLoad"
          type="number"
          value={inputs?.MinLoad}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Max. Load</Label>
        <Input
          autocomplete="new"
          name="MaxLoad"
          type="number"
          value={inputs?.MaxLoad}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

TariffForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default TariffForm;
